export default {
  'SPONSOR' (state) {
    return state.sponsor
  },
  'SPONSORS' (state) {
    return state.sponsors
  }
}
